<template>
  <button
    type="button"
    class="wizard-back-btn"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <i class="fa-regular fa-arrow-left" />
    <span>{{ label }}</span>
  </button>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'WizardBackButton',

  props: {
    label: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['click'],
});
</script>

<style lang="scss" scoped>
.wizard-back-btn {
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  padding: 8px 14px 8px 12px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 0.875rem;
  color: #334155;
  cursor: pointer;
  border-radius: 100px;
  transition: all 160ms ease;
  font-weight: 600;
  line-height: 1;

  &:hover:not(:disabled) {
    background: #e2e8f0;
    border-color: #cbd5e1;
    color: #0f172a;
    transform: translateX(-2px);
  }

  &:active:not(:disabled) {
    transform: translateX(-2px) scale(0.98);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  i {
    font-size: 0.8125rem;
  }
}
</style>
